var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { StyleItemWrapper } from '../StyleItemWrapper';
const defaultOptions = [0, 1, 2, 4, 5, 8];
const RESET = '((RESET))';
let Select = class Select extends Vue {
  constructor() {
    super(...arguments);
    this.specOptions = null;
  }
  get style() {
    return this.stylePanel.style;
  }
  handleSizeChange(value) {
    if (value === RESET) {
      this.$delete(this.style, this.propKey);
    } else {
      this.$set(this.style, this.propKey, value);
    }
  }
  handleSearch(value) {
    if (this.searchAndInput) {
      if (this.specOptions && !value) return;
      this.specOptions = value;
      this.handleSizeChange(value);
    }
  }
  get labeledOptions() {
    return this.options.map(item => {
      if (typeof item !== 'number' && item !== null && item !== void 0 && item.label && item !== null && item !== void 0 && item.value) {
        return item;
      }
      return {
        value: item,
        label: item
      };
    });
  }
  render() {
    const h = arguments[0];
    const value = this.style[this.propKey];
    return h(StyleItemWrapper, {
      "attrs": {
        "propKey": this.propKey,
        "title": this.title
      }
    }, [h("a-select", {
      "attrs": {
        "show-search": true,
        "placeholder": this.title,
        "value": value
      },
      "on": {
        "search": this.handleSearch,
        "change": this.handleSizeChange
      },
      "style": "min-width: 100px"
    }, [!!(value || value === 0) && h("a-select-option", {
      "attrs": {
        "value": RESET
      },
      "key": `preset-${RESET}`
    }, ["\u9ED8\u8BA4"]), this.labeledOptions.map(item => h("a-select-option", {
      "attrs": {
        "value": item.value
      },
      "key": `preset-${item.value}`
    }, [item.label]))])]);
  }
};
__decorate([Prop()], Select.prototype, "title", void 0);
__decorate([Prop()], Select.prototype, "propKey", void 0);
__decorate([Prop({
  type: Array,
  default: () => defaultOptions
})], Select.prototype, "options", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], Select.prototype, "searchAndInput", void 0);
__decorate([Inject()], Select.prototype, "stylePanel", void 0);
Select = __decorate([Component({})], Select);
export { Select };
//# sourceMappingURL=select.js.map
